import React from 'react'
import styles from './styles.scss'
import { adminCompaniesPath, adminAdsPath, adminCategoriesPath } from 'utils/paths'
import MenuItem from "./MenuItem"

class SideNav extends React.Component {
    
    render () {
        const { type } = this.props
        return (
            <div className={styles.container}> 
            <MenuItem path={adminCompaniesPath()}  isActive={type === "companies"}><p>Företag</p></MenuItem>
            <MenuItem path={adminCategoriesPath()}  isActive={type === "categories"} ><p>Kategorier</p></MenuItem>
            <MenuItem path={adminAdsPath()}  isActive={type === "ads"} ><p>Annonser</p></MenuItem>
            </div>
        )
    }
}

export default SideNav;


// WEBPACK FOOTER //
// src/components/SideNav/index.jsx